import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localizedDate',
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  /*
  This pipe is created because pipe are executed before the ngOninit
  and the currentLang was undefined
  */
  transform(date: any, pattern: string = 'mediumDate'): any {
    const currentLang = this.translate.currentLang;
    return  new DatePipe(currentLang).transform(date, pattern);
  }

}
